import i18n from "../../../public/i18n";

export const DAY_SIZE = 33;

export const TYPE_OPTIONS = [
  { value: "Single", label: "Singolo" },
  { value: "Double", label: "Congiunto" },
];

export const NOTES_TYPES = {
  NON_LEGGIBILE: "Non leggibile",
  DUPLICATO: "Duplicato",
  ALTRO: "Altro",
};

export const NOTES_OPTIONS = [
  NOTES_TYPES.NON_LEGGIBILE,
  NOTES_TYPES.DUPLICATO,
  NOTES_TYPES.ALTRO,
];

export const IDENTDOCUMENTS_NOTES = [
  "Documento non valido",
  "Documento di riconoscimento scaduto",
  "Immagine non leggibile",
  "Formato file non supportato",
  "Altro",
];

export const ORDER_BY = [
  {
    label: "Nome",
    value: "name",
  },
  {
    label: "Data del documento",
    value: "date",
  },
  {
    label: "Data di caricamento",
    value: "creationdate",
  },
  {
    label: "Importo",
    value: "amount",
  },
  {
    label: "Categoria",
    value: "category",
  },
  {
    label: i18n.t("Operator"),
    value: "commercialista",
  },
  {
    label: "Profilo fiscale",
    value: "fiscalprofile",
  },
];

export const FEATURE_FLAGS = {
  ALLOW_SAVE: true,
  NOTIFICATION: true,
  UPLOAD: true,
};

export const LOGO_UPLOAD_MAX_SIZE = 500 * 1024;
export const CHECK_NOTIFICATIONS_MILLISECONDS = 1000 * 60;

export const ORDER_BY_DOCS = [
  {
    label: "Nome",
    value: "name",
  },
  {
    label: "Data del documento",
    value: "date",
  },
  {
    label: "Data di caricamento",
    value: "creationdate",
  },
  {
    label: "Importo",
    value: "amount",
  },
  {
    label: "Categoria",
    value: "category",
  },
  {
    label: i18n.t("Operator"),
    value: "commercialista",
  },
];

export const ORDER_BY_PROCEDURES = [
  {
    label: "Nome",
    value: "name",
  },
  {
    label: "Data di caricamento",
    value: "creationdate",
  },
  {
    label: "Stato",
    value: "status",
  },
  {
    label: i18n.t("User"),
    value: "user",
  },
];

export const DOCUMENTS_UPDATE = "documents/force/update";

export const DOCUMENT_STATUS = {
  Complete: "Validato",
  Rejected: "Scartato",
};

const FILTERABLE_DOCUMENT_STATUS = ["Complete", "Rejected"];

export const DOCUMENT_STATUS_OPTIONS = Object.keys(DOCUMENT_STATUS).map(
  (k) => ({
    label: DOCUMENT_STATUS[k],
    value: k,
  })
);

export const FILTER_DOCUMENT_STATUS_OPTIONS = Object.keys(DOCUMENT_STATUS)
  .filter((k) => FILTERABLE_DOCUMENT_STATUS.includes(k))
  .map((k) => ({
    label: DOCUMENT_STATUS[k],
    value: k,
  }));

export const ORDER_BY_DOCS_PROCEDURES = [
  {
    label: "Data di caricamento",
    value: "creationdate",
  },
  {
    label: "Data del documento",
    value: "date",
  },
];
